import * as types from './types';

export const changeOrdersVersion = () => ({
  type: types.CHANGE_ORDERS_VERSION
});
